export default __webpack_public_path__ + "static/es-e3471d73993a1d499c2ab07fe350185e.svg";